module.exports = __webpack_public_path__ + "static/media/Avante-01.a72c1b74.svg";